export default __webpack_public_path__ + "static/media/EthanHammerand.68238d31.jpg";